module.exports = __webpack_public_path__ + "static/media/L_02.947fa215.jpg";